import moment from 'moment';
import 'moment/locale/de';
moment.locale('de');

interface ICacheEntry {
	oc: string
	d: string
	w: string
	dayofweek: string
}

const cache = new Map<string, ICacheEntry>();

function toCacheEntry(utcDateAndHour: string) : ICacheEntry {
	utcDateAndHour = utcDateAndHour.substring(0, 13);
	{
		const result: ICacheEntry | undefined = cache.get(utcDateAndHour);
		if (result) return result;
	}
	const m = moment.utc(utcDateAndHour).local();
	const result: ICacheEntry = {
		oc: m.format('YYMMDD-HH'),
		d: m.format('DD.MM.YYYY HH'),
		w: m.format('WW'),
		dayofweek: m.format('ddd')
	};
	cache.set(utcDateAndHour, result);
	return result;
}

const timestampTo = {
	date: function(s: string) {
		const e = toCacheEntry(s);
		return e.d.substring(0, 10);
	},
	yearmonth: function(s: string) {
		const e = toCacheEntry(s);
		return e.oc.substring(0, 4);
	},
	time: function(s: string) {
		const e = toCacheEntry(s);
		return e.d.substring(11, 13) + s.substring(13, 16);
	},
	timelong: function(s: string) {
		const e = toCacheEntry(s);
		return e.d.substring(11, 13) + s.substring(13);
	},
	datetime: function(s: string) {
		const e = toCacheEntry(s);
		return e.d + s.substring(13, 16);
	},
	datetimelong: function(s: string) {
		const e = toCacheEntry(s);
		return e.d + s.substring(13);
	},
	week: function(s: string) {
		const e = toCacheEntry(s);
		return e.w;
	},
	dayofweek: function(s: string) {
		const e = toCacheEntry(s);
		return e.dayofweek;
	},
};

const dateTo = {
	date: function(s: string) {
		return s.substring(8, 10) + '.' + s.substring(5, 7) + '.' + s.substring(0, 4);
	},
};

const millisTo = {
	timestampWithMillis: function(d) {
		return moment(d).utc().format('YYYY-MM-DD HH:mm:ss.SSS');
	},
};

const momentTo = {
	date: function(m) {
		return m.format('YYYY-MM-DD');
	},
	time: function(m) {
		return m.format('HH:mm:ss');
	},
};

export const Momentino = {timestampTo, dateTo, millisTo, momentTo};
